define(
    'services/busy',[
    ],
    function () {

        var busy = function () {
            var self = this;
            
        };

        return busy;

    });
